import actions from './actions'

const initialState = {
  messages: null,
}

export default function chatReducer(state = initialState, action) {
  // console.log(action)
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
